import { render, staticRenderFns } from "./MainDomain.vue?vue&type=template&id=49e1d690&scoped=true"
import script from "./MainDomain.vue?vue&type=script&lang=js"
export * from "./MainDomain.vue?vue&type=script&lang=js"
import style0 from "./MainDomain.vue?vue&type=style&index=0&id=49e1d690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1d690",
  null
  
)

export default component.exports